export const STATUS_ENUM = {
    SCHEDULE : "scheduled",
    LIVE : "live",
    CLOSED : "closed",
 }
 export const ADD_BROADCAST_ACTION ={
    NEW_BROADCAST:"new_broadcast",
    BROADCAST_DETAILS:"broadcast_details"
 }
//  export const broadcastColumnConfig = [
//    { name: 'title', flex: 1 },
//    { name: 'message', flex: 3 },
//    { name: 'recipients', flex: 1 },
//    { name: 'startdate', flex: 1 },
//    { name: 'enddate', flex: 1 },
//  ];

 export const broadcastColumnConfig = [
   { name: 'title', width: '20%' },
   { name: 'message', width: '42.5%' },
   { name: 'recipients', width: '12.5%' },
   { name: 'startdate', width: '12.5%' },
   { name: 'enddate', width: '12.5%' },
 ];
 
